/** Supplied text remains authoritative: controls filter columns, never convert sizing. */
class VoltSizeGuide extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const { signal } = this.abort;
    const articles = [...this.querySelectorAll('[data-size-chart]')];
    const picker = this.querySelector('[data-chart-picker]');
    if (picker) {
      picker.replaceChildren(new Option('Choose a size chart', ''));
      articles.forEach(article => picker.add(new Option(article.dataset.chartLabel, article.dataset.sizeChart)));
      picker.closest('label').hidden = articles.length < 2;
      const selectChart = () => {
        articles.forEach(article => { article.hidden = article.dataset.sizeChart !== picker.value; });
        this.querySelector('[data-chart-prompt]').hidden = Boolean(picker.value);
      };
      picker.value = articles.some(a => a.dataset.sizeChart === this.dataset.defaultChart) ? this.dataset.defaultChart : articles.length === 1 ? articles[0].dataset.sizeChart : '';
      picker.addEventListener('change', selectChart, { signal });
      selectChart();
    }
    articles.forEach(article => {
      const groups = [...article.querySelectorAll('[data-filter]')];
      groups.forEach(group => {
        group.hidden = false;
        const buttons = [...group.querySelectorAll('button')];
        const apply = value => {
          buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.value === value)));
          article.querySelectorAll(`[data-${group.dataset.filter}]`).forEach(cell => {
            cell.hidden = cell.dataset[group.dataset.filter] !== value;
          });
        };
        group.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (button && group.contains(button)) apply(button.dataset.value);
        }, { signal });
        apply(buttons[0].dataset.value);
      });
    });
    const scroller = this.closest('.volt-information-drawer__body');
    const links = [...this.querySelectorAll('[data-guide-link]')];
    const sections = [...this.querySelectorAll('[data-guide-section]')];
    const nav = this.querySelector('nav');
    this.addEventListener('click', event => {
      const link = event.target.closest('[data-guide-link]');
      if (!link || !this.contains(link)) return;
      const target = sections.find(section => '#' + section.id === link.getAttribute('href'));
      if (!target || !scroller) return;
      event.preventDefault();
      target.focus({ preventScroll: true });
      scroller.scrollTo({ top: scroller.scrollTop + target.getBoundingClientRect().top - scroller.getBoundingClientRect().top - nav.offsetHeight, behavior: 'instant' });
    }, { signal });
    const updateNavigation = () => {
      const edge = scroller.getBoundingClientRect().top + nav.offsetHeight + 8;
      let current = sections[0];
      sections.forEach(section => { if (section.getBoundingClientRect().top <= edge) current = section; });
      links.forEach(link => {
        if (link.getAttribute('href') === '#' + current?.id) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    };
    scroller?.addEventListener('scroll', updateNavigation, { signal, passive: true });
    this.closest('dialog')?.addEventListener('toggle', updateNavigation, { signal });
    if (scroller) updateNavigation();
  }
  disconnectedCallback() { this.abort?.abort(); }
}
if (!customElements.get('volt-size-guide')) customElements.define('volt-size-guide', VoltSizeGuide);
